import { useRef } from 'react';
import { modals } from '@mantine/modals';
import { PasswordInput, Stack } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import { usePinLogin, IPinLoginResponse } from '../auth/mutations';

export function useRequestPinLogin() {
  const { mutateAsync: pinLogin } = usePinLogin();
  const pinCodeRef = useRef<HTMLInputElement>(null);

  const requestPinLogin = (): Promise<IPinLoginResponse | null> => {
    return new Promise((resolve) => {
      return ConfirmationModal({
        modalId: 'request-pin-login-modal',
        closeOnConfirm: false,
        title: 'Cambiar sesión por PIN',
        children: (
          <Stack>
            <PasswordInput
              type="tel"
              autoFocus
              label="PIN del usuario que tomará la sesión"
              placeholder="••••"
              maxLength={6}
              minLength={4}
              ref={pinCodeRef}
            />
          </Stack>
        ),
        onConfirm: async () => {
          const pin = pinCodeRef.current?.value || '';
          if (!/^\d{4,6}$/.test(pin)) {
            showNotification({
              title: 'PIN inválido',
              message: 'El PIN debe tener entre 4 y 6 números',
              color: 'red'
            });
            return;
          }

          try {
            const res = await pinLogin({ pinCode: pin });
            if (res?.token) {
              modals.close('request-pin-login-modal');
              resolve(res);
              showNotification({
                title: 'Sesión cambiada',
                message: `Cambiando sesión a ${res.user.name}`,
                color: 'green'
              });
            } else {
              showNotification({
                title: 'PIN incorrecto',
                message: 'No se encontró un usuario con ese PIN',
                color: 'red'
              });
            }
          } catch (e) {
            showNotification({
              title: 'Error',
              message: 'No se pudo cambiar la sesión',
              color: 'red'
            });
          }
        },
        onCancel: () => resolve(null)
      });
    });
  };

  return {
    requestPinLogin
  };
}
